import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import Cookies from "js-cookie";
import SidebarStudent from "./Utils/SidebarStudent";
import { logout } from "../apis/backend";
import "./Dashboard.css";
import { useStudentProgress } from "../context/StudentProgressContext";
import { toast } from "../utils/toast";
import LogoutButton from "./LogoutButton";

const Declaration: React.FC = () => {
    const navigate = useNavigate();
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const [isAgreed, setIsAgreed] = useState(false);
    const { refreshProgress } = useStudentProgress();

    const handleFinalSubmit = async (): Promise<void> => {
        try {
            // For now, we rely on a cookie to track completion of declaration
            Cookies.set("declarationAgreed", "true", { expires: 365 });
            await refreshProgress();

            toast.success("Application Submitted Successfully!");
            navigate("/applicant/home"); // Navigate back to the student home or a success page
        } catch (error) {
            console.error("Submission failed:", error);
            toast.error("Unable to submit application. Please try again.");
        }
    };

    return (
        <div className="dash-layout">
            <SidebarStudent
                sidebarCollapsed={sidebarCollapsed}
                toggleSidebar={() => setSidebarCollapsed((p) => !p)}
            />

            <div
                className={`dash-wrapper ${sidebarCollapsed ? "dash-wrapper-collapsed" : ""}`}
            >
                <header className="dash-header">
                    <h1 className="dash-page-title">Declaration & Final Submission</h1>

                    <div className="dash-user-profile">
                        <div
                            className="dash-profile-circle"
                            onClick={() => setShowDropdown((p) => !p)}
                        >
                            <span>S</span>
                        </div>

                        {showDropdown && (
                            <div className="dash-profile-dropdown">
                                <LogoutButton />
                            </div>
                        )}
                    </div>
                </header>

                <div className="dash-content-body">
                    <div className="m-4">
                        <div
                            className="border rounded p-4 bg-white"
                            style={{ borderColor: "#2D88D4" }}
                        >
                            <div className="mb-3">
                                <a href="#" className="text-decoration-underline text-secondary fw-bold">
                                    Instruction/Guidelines
                                </a>
                            </div>

                            <div className="mb-4 text-muted">
                                I declare that the information provided is true to the best of my knowledge and I understand that providing any
                                false information may lead to the rejection of the application and make me liable for legal proceedings.
                            </div>

                            <div className="form-check mb-4">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="agreeCheck"
                                    checked={isAgreed}
                                    onChange={(e) => setIsAgreed(e.target.checked)}
                                    style={{ cursor: "pointer" }}
                                />
                                <label className="form-check-label text-muted" htmlFor="agreeCheck" style={{ cursor: "pointer" }}>
                                    I Agree
                                </label>
                            </div>

                            <div className="d-flex justify-content-center">
                                <button
                                    onClick={handleFinalSubmit}
                                    disabled={!isAgreed}
                                    className="btn text-white px-4 py-2"
                                    style={{
                                        background: isAgreed ? "#28a745" : "#a1d6b0", // Greenish for final submit
                                        fontSize: "16px",
                                        borderRadius: "5px",
                                        cursor: isAgreed ? "pointer" : "not-allowed",
                                    }}
                                >
                                    Submit Application
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Declaration;
